import { Navigate } from "react-router-dom";
import { NotFound } from "../shared/pages/NotFound";
import { ROUTES } from "../shared/utils";

export const fallbackRoutes = [
  {
    path: "/",
    element: <Navigate to={ROUTES.DASHBOARD} replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
